import { Card } from "@/components/Card/card";
import { HStack, VStack } from "@/components/Layout";
import { ViewportLoader } from "@/components/Loading";
import { createFileRoute } from "@tanstack/react-router";
import { DeliveryCard } from "../-components/DeliveryCard";
import { HandoverNoteCard } from "../-components/HandoverNoteCard";
import { OrderDetailsCard } from "../-components/OrderDetailsCard";
import { OrderDetailsSummaryCard } from "../-components/OrderDetailsSummaryCard";
import { OrdererCard } from "../-components/OrdererCard";
import { ShippingCard } from "../-components/ShippingCard";
import { StatusTimeline } from "../-components/StatusTimeline";
import { VendorCard } from "../-components/VendorCard";
import { useSentOrderDetailQuery } from "../-query/api";

export const Route = createFileRoute(
  "/_staff/marketplace/sent-orders/$orderId/_layout/",
)({
  component: OrderDetail,
});

function OrderDetail() {
  const { orderId } = Route.useParams();
  const { data: order, isLoading } = useSentOrderDetailQuery(orderId);

  if (isLoading) return <ViewportLoader />;
  if (!order) return null;

  return (
    <div className="p-12">
      <HStack className="gap-8">
        <VStack className="flex-1 gap-4">
          <OrdererCard orderer={order.orderer} />
          <ShippingCard address={order.shippingAddress} />
          <OrderDetailsCard lines={order.lines} />
          <OrderDetailsSummaryCard summaryPrices={order.summaryPrices} />
          <DeliveryCard deliveryDate={order.deliveryDate} />
          <HandoverNoteCard memo={order.handoverMemo} />
          <VendorCard supplier={order.supplier} />
        </VStack>
        <Card className="h-fit w-80 p-4">
          <StatusTimeline
            orderId={orderId}
            activities={order.activities}
            canProductReceive={order.canProductReceive}
          />
        </Card>
      </HStack>
    </div>
  );
}
